import React, { useEffect, useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { redirectToPages } from "../../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader
} from "../../../../../../../_metronic/_partials/controls";
import { StudentsFilter } from "./students-filter/StudentsFilter";
import { StudentsTable } from "./students-table/StudentsTable";
import { useStudentsUIContext } from "./StudentsUIContext";

export function StudentsCard({
  setReceipentIds
}) {
  // Students Card UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      ids: studentsUIContext.ids
    };
  }, [studentsUIContext]);

  // Getting curret state of Students from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.privateNotices }),
    shallowEqual
  );  
  const { isSuccess, type } = currentState;

  useEffect(() => {    
    setReceipentIds(studentsUIProps.ids);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentsUIProps.ids]);

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  const title = <>Öğrenci Listesi{studentsUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{studentsUIProps.ids.length}</span>]</> :
                   ""}
                </>;

  return (
    <Card>
      <CardHeader title={title} />
      <CardBody>
        <StudentsFilter />
        <StudentsTable />
      </CardBody>
    </Card>
  );
}